export const categoriesFallback = [
  {
    id: '1',
    title: { da: 'Profiltøj' },
    description: { da: '<p>Profilbeklædning, der styrker jeres brand og skaber sammenhold. Vi leverer kvalitetstøj med professionelt tryk og broderi:</p><ul><li>T-shirts, poloshirts og sweatshirts til hverdagen</li><li>Klassiske skjorter og strik til kontoret og kundemøder</li><li>Jakker og overtøj til alle sæsoner</li><li>Stort udvalg og pasformer, der matcher jeres visuelle identitet</li></ul><p>Lad os hjælpe jer med at skabe et professionelt og ensartet udtryk for jeres medarbejdere.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/5fc97ec2-19cb-4d24-825d-3e36710c0873.png'],
    slug: { da: 'profiltoej' },
    subcategories: [
      {
        title: 'Cutter & Buck',
        description: 'Eksklusivt profiltøj i klassisk amerikansk design med fokus på detaljer, pasform og uovertruffen kvalitet.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/05a0f70b-7fd0-4968-afd6-d226e244ad62.png',
        link: 'https://viewer.joomag.com/cutterbuck-ss26-da-english-text-with-price/0247643001765805421?short&'
      },
      {
        title: 'Cutter & Buck Junior',
        description: 'Kvalitetsbeklædning til de yngre, der kombinerer slidstyrke med det klassiske og stilrene Cutter & Buck-look.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/f47dc874-5d23-4882-acdf-dff28cbc17d2.png',
        link: 'https://viewer.joomag.com/cutterbuck-ss26-206x300-juniorgolfcollection/0555279001777354986?short&'
      },
      {
        title: 'Clique',
        description: 'Det perfekte valg til hverdagens profiltøj. Et bredt udvalg af farver, modeller og størrelser med fantastisk trykbarhed.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/d37a9f8d-9194-4ffb-99e2-5ad7ad072f98.png',
        link: 'https://viewer.joomag.com/clique-2026-dansk/0690043001768312945?short&'
      },
      {
        title: 'Movement',
        description: 'Aktivt profiltøj med fokus på bevægelsesfrihed, åndbarhed og moderne, sporty snit til en active arbejdsdag.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/fe3c36c1-1089-4dba-99d0-9af5c8271697.png',
        link: 'https://viewer.joomag.com/untagged-movement-2025/0645585001762177140?short&'
      },
      {
        title: 'Jakker',
        description: 'Stort udvalg af overtøj og jakker til alle sæsoner – fra lette softshells to varme, vind- og vandtætte vinterjakker.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/d2c54f45-05a0-4ebf-8056-ff11196bf9b9.png',
        link: 'https://viewer.joomag.com/jakkekatalog-ss-2026/0102322001775643939'
      }
    ]
  },
  {
    id: '2',
    title: { da: 'Sportstøj' },
    description: { da: '<p>Sportstøj til holdet, klubben eller virksomheden med fokus på ydeevne:</p><ul><li>Kvalitetsmærker som Craft og New Balance</li><li>Åndbare materialer og optimal pasform</li><li>Løbetøj til firmaets motionsklub</li><li>Spillersæt til lokale sportsklubber</li></ul>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/2751f8a3-ee4c-4ebf-96d1-7be1e721b182.png'],
    slug: { da: 'sportstoej' },
    subcategories: [
      {
        title: 'Golftøj (Cutter & Buck)',
        description: 'Eksklusivt golftøj og profiltøj i klassisk amerikansk design med fokus på detaljer, pasform og uovertruffen kvalitet.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/05a0f70b-7fd0-4968-afd6-d226e244ad62.png',
        link: 'https://viewer.joomag.com/cutterbuck-ss26-da-english-text-with-price/0247643001765805421?short&'
      },
      {
        title: 'Craft',
        description: 'Højtydende sportstøj og funktionelt træningstøj fra Craft Sportswear, udviklet til optimal ydeevne og komfort.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/bbb5ffed-8be5-4e59-9bc5-b964c19233fc.png',
        links: [
          { label: 'Corporate Catalogue SS26', url: 'https://viewer.joomag.com/corporate-catalogue-ss26/0199348001768404785?short&' },
          { label: 'Teamwear Katalog 2026', url: 'https://viewer.joomag.com/teamwear-katalog-2026/0635273001736342219?short&' }
        ]
      },
      {
        title: 'LØB',
        description: 'Professionelt løbetøj med fokus på åndbarhed, letvægtsmaterialer og perfekt pasform til både motionister og elite.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/b1341979-c5a0-41d2-bb6f-37d59609ea82.png',
        link: 'https://viewer.joomag.com/l%C3%98b-2026/0237738001773042364?short&'
      },
      {
        title: 'PADEL',
        description: 'Stilrent og funktionelt padeltøj og udstyr, der sikrer maksimal bevægelsesfrihed og komfort på banen.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/71f659be-7255-4e09-b295-e20013cf48be.png',
        link: 'https://viewer.joomag.com/padel-flyer-2025/0846123001760596261?short&'
      },
      {
        title: 'SPECIALDESIGN',
        description: 'Skab jeres helt eget unikke udtryk. Vi designer og producerer specialdesignet sportstøj i jeres klub- eller virksomhedsfarver.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/bba8c188-c988-430e-adc0-e2fe511c57c4.png',
        links: [
          { label: 'CSTM Run 2026', url: 'https://viewer.joomag.com/cstm-run-2026/0851576001770278574?short&' },
          { label: 'CSTM Bike 2026', url: 'https://viewer.joomag.com/cstm-bike-2026/0920825001770278558?short&' },
          { label: 'CSTM Team 2026', url: 'https://viewer.joomag.com/cstm-team-2026/0144892001770278648?short&' },
          { label: 'CSTM Flyer 2025', url: 'https://viewer.joomag.com/cstm-flyer-2025/0319905001742983748?short&' },
          { label: 'Clear Collar 2023', url: 'https://viewer.joomag.com/clear-collar-2023/0728962001692734090?short&' },
          { label: 'Special Design Brandet 2026', url: 'https://viewer.joomag.com/special-design-brandet-2026/0104770001738794067?short&' },
          { label: 'Branded SS25', url: 'https://viewer.joomag.com/branded-ss25/0871835001739795581?short&' }
        ]
      }
    ]
  },
  {
    id: '3',
    title: { da: 'Padel' },
    description: { da: '<p>Alt i tøj og udstyr til den hurtigst voksende sport. Vi klæder jeres padel-hold eller virksomhed perfekt på til banen:</p><ul><li>Spillesæt, t-shirts og shorts i svedtransporterende materialer</li><li>Padelbat og tilbehør fra førende mærker som Babolat</li><li>Logotryk på tøjet, så jeres brand står skarpt under kampen</li><li>Løsninger til både firma-turneringer og klubber</li></ul><p>Gør jer klar til næste kamp med professionelt padel-udstyr.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/71f659be-7255-4e09-b295-e20013cf48be.png'],
    slug: { da: 'padel' }
  },
  {
    id: '4',
    title: { da: 'Specialdesign' },
    description: { da: '<p>Unikke løsninger skræddersyet helt efter jeres ønsker og behov. Når standardvarer ikke er nok, designer vi fra bunden:</p><ul><li>Specialdesignede detaljer, farvekombinationer og snit</li><li>Unikke labels, nakke-mærkater og special-emballage</li><li>Produkter fremstillet specifikt til jeres kampagne eller brand</li><li>Professionel rådgivning fra idé til færdigt produkt</li></ul><p>Skab noget helt unikt, som jeres kunder og medarbejdere vil huske.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/bba8c188-c988-430e-adc0-e2fe511c57c4.png'],
    slug: { da: 'specialdesign' }
  },
  {
    id: '5',
    title: { da: 'Arbejdstøj' },
    description: { da: '<p>Vi tilbyder et bredt udvalg af arbejdstøj til alle brancher, hvor kvalitet og komfort altid er i højsædet:</p><ul><li>Slidstærke bukser og jakker til alle typer håndværk</li><li>Specialiseret sikkerhedsudstyr og certificeret beklædning</li><li>Profiltøj med logotryk og broderi</li><li>Løsninger to både små og store virksomheder</li></ul><p>Vi sikrer, at jeres medarbejdere er klædt professionelt på og føler sig godt tilpas hele dagen.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/01db8106-a689-4c45-a294-3070a99cde01.png'],
    slug: { da: 'arbejdstoej' },
    subcategories: [
      {
        title: 'Projob',
        description: 'Ergonomisk og slidstærkt arbejdstøj med fokus på funktionalitet, pasform og innovative detaljer to den professionelle håndværker.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/ef10e760-9ffc-45ee-8ed5-c2d5e6d98970.png',
        link: 'https://viewer.joomag.com/2026-projob-workwear-dk/0785470001771921913?short&'
      },
      {
        title: 'Jobman',
        description: 'Professionelt og funktionelt arbejdstøj udviklet to at beskytte og yde maksimal komfort i alle arbejdssituationer. Se det fulde katalog online.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/a7dc0c4b-b3d1-4bda-9d91-5d717393acfb.png',
        link: 'https://viewer.joomag.com/jobman-2026-eng/0758926001739873243/p54?short='
      }
    ]
  },
  {
    id: '6',
    title: { da: 'Firmatøj' },
    description: { da: '<p>Eksklusivt tøj til virksomhedens ansatte, perfekt til kontoret, messer og hverdagen:</p><ul><li>Skjorter, blazere og pæne bukser i høj kvalitet</li><li>Lækre strikvarer og cardigans fra kendte mærker</li><li>Diskret broderi eller tryk af jeres firmalogo</li><li>Komfortable og præsentable løsninger til alle medarbejdere</li></ul><p>Præsenter jeres virksomhed på bedste vis med stilrent og komfortabelt firmatøj.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/frost-kat.jpg'],
    slug: { da: 'firmatoej' },
    subcategories: [
      {
        title: 'ID Identity',
        description: 'Klassisk og slidstærkt firmatøj med fokus på ensartet udtryk, høj kvalitet og fantastisk holdbarhed til hverdagen.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/a3aa5a70-9ead-4836-a67f-f5c192cfdcc1.png'
      },
      {
        title: 'J.Harvest & Frost',
        description: 'Eksklusive og stilfulde kvalitetsskjorter og firmatøj til kontoret og præsentative formål. Se det nyeste katalog online.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/frost-kat.jpg',
        link: 'https://viewer.joomag.com/j-harvest-frost-2026-eng/0884473001765285031?short&'
      },
      {
        title: 'Efterskole / Forening',
        description: 'Specialdesignet fællesbeklædning, hættetrøjer og holdtøj, der styrker fællesskabet og holdånden på efterskolen eller i klubben.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/a9f946e3-017d-4601-952b-50d926b42fbc.png'
      },
      {
        title: 'Texet Danmark',
        description: 'Et stærkt udvalg af profilbeklædning og firmatøj, der kombinerer moderne design med høj funktionalitet og god komfort.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/440d8707-72a6-421b-a8f3-1bdfcaedb106.png'
      },
      {
        title: 'Tenson',
        description: 'Teknisk overtøj og funktionelt firmatøj in svensk design, skabt til at modstå vind og vejr med stil.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/1508dcc4-2af2-48a9-8891-4b9057d0522a.png'
      }
    ]
  },
  {
    id: '7',
    title: { da: 'Tryk & Broderi' },
    description: { da: '<p>Hos HN Promotion tilbyder vi professionel profilering af jeres firmatøj med både tryk og broderi. Vi sikrer, at jeres logo står skarpt og holder til hverdagens slid og vask:</p><ul><li>Professionelt logotryk (transfertryk) med høj farveægthed</li><li>Eksklusivt direkte broderi på skjorter, strik, poloshirts og huer</li><li>Specialdesignede vævede, gummierede eller læder-mærker</li><li>Rådgivning om den bedste branding-metode til jeres specifikke produkter</li></ul><p>Vi hjælper dig med at vælge den rette løsning, der matcher jeres visuelle identitet og produkternes anvendelse.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/b8ae698d-1ec7-40e9-83b9-d3e770898d12.jpg'],
    slug: { da: 'tryk-broderi' },
    subcategories: [
      {
        title: 'Logotryk / Transfer',
        description: 'Det perfekte valg til t-shirts, sportstøj, sweatshirts og lette jakker. Giver et knivskarpt resultat med præcise farver og høj holdbarhed.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/12310529-4834-4507-ae94-0acec4f5c2db.jpg'
      },
      {
        title: 'Eksklusivt Broderi',
        description: 'Det klassiske og mest slidstærke valg til skjorter, strik, poloshirts, softshells og huer. Giver et elegant 3D-look, der udstråler kvalitet.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/b8ae698d-1ec7-40e9-83b9-d3e770898d12.jpg'
      },
      {
        title: 'Specialmærker',
        description: 'Vævede mærker, gummimærker eller læderpatches, der syes eller presses på tøjet. Ideelt til caps, tasker og moderne profilbeklædning.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/3e4c2684-6864-4e68-a987-4227a0efddab.jpg'
      }
    ]
  },
  {
    id: '8',
    title: { da: 'Firmagaver / Jul' },
    description: { da: '<p>Find den perfekte gave, der spreder glæde og viser påskønnelse:</p><ul><li>Stort udvalg af julegaver og firmagaver</li><li>Lækre delikatesser og eksklusive designikoner</li><li>Praktisk udstyr og luksuriøse tekstiler</li><li>Totalløsninger med pakning og distribution</li></ul>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/func-katalog.jpg'],
    slug: { da: 'firmagaver-jul' },
    subcategories: [
      {
        title: 'Julen 2026',
        description: 'Eksklusive designgaver, belysning og hygge til højtiden. Gå på opdagelse vha. det nyeste katalog fra Func med Uyuni, EKTA og Wattson.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/func-katalog.jpg',
        link: 'https://shop83905.sfstatic.io/upload_dir/docs/Kataloger/Uyuni%2C-EKTA-%26-Wattson-katalog-2026---Func%2C-en-del-af-Piffany-Copenhagen.pdf'
      },
      {
        title: 'Gavekort',
        description: 'Gør julegaven nem og personlig. Vi tilbyder skræddersyede gavekortløsninger og et bredt udvalg af luksuriøse julegaver.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/9c2c65f1-c44a-4fda-9b87-49255407800d.jpg',
        link: 'https://viewer.joomag.com/jg-plus-online-flyer-2026-27/0246785001745926941'
      },
      {
        title: 'Gaveartikler',
        description: 'Stort udvalg af eksklusive firmagaver, merchandise og reklameartikler, der styrker jeres brand og glæder modtageren.',
        image: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/e7b575bc-d490-4cfc-b086-0451662bc3bf.png',
        links: [
          { label: 'Profile Collection SS26', url: 'https://viewer.joomag.com/ss26-profile-collection-dk/0456105001765522717?short&' },
          { label: 'Sagaform Retail SS26', url: 'https://viewer.joomag.com/sagaform-ss26-retail/0464093001768403605?short&' },
          { label: 'ByOn Profil SS26', url: 'https://viewer.joomag.com/byon-ss26-profil/0455772001765184612?short&' },
          { label: 'Orrefors 2026', url: 'https://viewer.joomag.com/orrefors-catalogue-export-2026/0721069001767773291?short&' }
        ]
      }
    ]
  },
  {
    id: '9',
    title: { da: 'Jagt/outdoor' },
    description: { da: '<p>Kvalitetsbeklædning og udstyr til jagt og outdoor-aktiviteter. Vi tilbyder slidstærkt og funktionelt tøj fra førende mærker som Pinewood, der sikrer dig optimal komfort og beskyttelse i naturen:</p><ul><li>Vind- og vandtætte jagtjakker og -bukser</li><li>Åndbare mellemlag, strik og fleece til kolde dage</li><li>Slidstærkt outdoortøj til vandring og fritid</li><li>Praktisk tilbehør som huer, handsker og tasker</li></ul><p>Uanset om du skal på jagt eller vandretur, klæder vi dig rigtigt på til naturens udfordringer.</p>' },
    image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/image001-hn.jpg'],
    slug: { da: 'jagt-outdoor' },
    subcategories: [
      {
        title: 'Pinewood',
        description: 'Svensk kvalitetstøj til jagt, fiskeri og outdoor. Funktionelt tøj med gennemtænkte detaljer og høj komfort til alle vejrforhold.',
        image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/jagtogoutdoorhn1.jpg',
        link: 'https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/woorkbook-ss2026.pdf'
      }
    ]
  }
];

export const showroomFallback = {
  title: { da: 'Besøg vores Showroom' },
  content: { da: '<p>Kom og besøg os i vores showroom, hvor du kan se og prøve vores store udvalg af arbejdstøj, sportstøj og firmagaver.</p>' },
  hero_image: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/f299cec7-df78-4423-ab45-676f8e2adf52.jpeg'],
  gallery: [
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/4c484770-e507-476b-82ae-68bb077541af.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/7354242f-4a41-4fb9-9ed2-ec81855b1ae7.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/38a96a74-d0b0-4840-a763-7dc3c98b5db8.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/f6522fa4-a90b-43ce-b347-2ad93d9047b3.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/61cab01f-1a3a-4f4c-9034-fad2be3ac992.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/8f96f26f-1860-4abd-8dcf-5846e082c2b9.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/b429f231-f14d-456d-abe7-3a2a8ced1c48.jpeg",
    "https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/659ee5dd-7353-424b-9b2f-2f536a5ec707.jpeg"
  ]
};
